<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th>Pickeador</th>
          <th>Fecha inicio</th>
          <th>Fecha Fin</th>                   
          <th class="text-center">Categorías</th>
          <th class="text-center">Subcategorías</th>
          <th class="text-center">Total</th> 
          <!-- <th>Activos</th>   
          <th>Inactivos</th>-->
        </tr>
      </thead>
      <tbody>
        <tr v-for="current in dataTabla.results" v-bind:key="current.id" @click="
          rowClick('wms-tarea-usuario-editar-tareas', {
            id: current.pickeador_obj.id,
          })
          ">
          <td>{{current.pickeador_obj.username }}</td>
          <td>{{current.fecha_inicio}}</td>
          <td>{{current.fecha_fin }}</td>             
          <td class="text-center">{{current.categoria_activa}} <span style="font-size: 11px">Asignadas</span></td>
          <td class="text-center">{{current.subcategoria_activa   }} <span style="font-size: 11px">Asignadas</span></td>          
          <td class="text-center">{{current.total}} <span style="font-size: 11px">Asignadas</span></td>       
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props: ["dataTabla"],
  mounted() { },
  methods: {
    rowClick(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      if (event.ctrlKey) {
        console.log("abriendo pantalla (ctrl+click) con id: ", params)
        let routeUrl = this.$router.resolve({
          name: name,
          params: params,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        console.log("abriendo pantalla (normal) con id: ", params.id)
        this.$router.push({
          name: name,
          params: params,
        });
      }
    },
  },
};
</script>
